<template>
  <div class="headerPage">
    <div class="site_nav flex-between">
      <div class="logo">
        <el-image
          style="width: 251px; height: 27px"
          :src="require('@/assets/images/login_logo3.png')"
        ></el-image>
      </div>
      <div class="right flex-rowr">
        <div class="user flex-rowl">
          <div class="tx">
            <img src="" alt="" v-if="USERINFO.headimg" />
            <i class="iconfont icon-yonghu" v-else></i>
          </div>
          您好：{{ USERINFO.truename }}
        </div>
        <div class="exit flex-rowl" @click="handleExit">
          <i class="iconfont icon-tuichu"></i>退出登录→
        </div>
      </div>
    </div>
    <div class="head_wrap flex-rowl">
      <div class="icon flex-rowl"><i class="iconfont icon-diejia"></i></div>
      <ul class="flex-rowl">
        <li
          v-for="(item, index) in list"
          :key="index"
          :class="{ active: headActive == index }"
          @click="handleGo(item, index)"
        >
          {{ item.txt }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import storage from "../utils/storage";
export default {
  name: "myHeader",
  data() {
    return {
      list: [
        {
          txt: "首页",
          url: "/home",
        },
        {
          txt: "管理",
          url: "/manage",
        },
        {
          txt: "数据",
          url: "",
        },
        {
          txt: "帮助",
          url: "",
        },
        {
          txt: "消息",
          url: "",
          // url: "/message",
        },
        {
          txt: "我的",
          url: "/mine",
        },
      ],
      // list: ['首页', '管理' ,'数据', '帮助', '消息']
    };
  },
  created() {
    this.$watch(() => {
      if (this.$route.path == "/home") {
        // this.tabbarActive = 0;
        this.$store.commit("updateHeadActive", 0);
      } else if (this.$route.path == "/manage") {
        // this.tabbarActive = 1;
        this.$store.commit("updateHeadActive", 1);
      } else if (this.$route.path == "/mine") {
        // this.tabbarActive = 5;
        this.$store.commit("updateHeadActive", 5);
      }
    });
  },
  computed: {
    ...mapState(["USERINFO", "headActive", "userLoginType"]),
  },
  methods: {
    handleExit() {
      this.$confirm("是否确认退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        storage.removeAll();
        if(this.userLoginType == 1) {
          this.$router.push("/qyLogin/${userid}/${token}");
        }else {
          this.$router.push("/login");
        }
      });
    },

    handleGo(item, index) {
      if (item.url != "") {
        this.$router.push(item.url);
        this.$store.commit("updateHeadActive", index);
      } else {
        this.$message.warning("即将开放");
      }
    },
  },
};
</script>
<style lang="less" scoped>
.headerPage {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.05);
  .site_nav {
    height: 60px;
    background: #f0f0f0;
    padding: 0 48px 0 65px;
    font-size: 16px;
    color: #4b4b4b;
    .right {
      .user {
        margin-right: 170px;
        .icon-yonghu {
          font-size: 24px;
          margin-right: 5px;
        }
      }
      .exit {
        cursor: pointer;
        .icon-tuichu {
          font-size: 24px;
          margin-right: 14px;
        }
      }
    }
  }
  .head_wrap {
    padding: 26px 65px;
    background: #fff;
    font-size: 18px;
    color: #000000;
    .icon {
      // margin-right: ;
      .icon-diejia {
        font-size: 20px;
        color: #515151;
      }
    }
    ul {
      li {
        padding: 0 7px 7px;
        margin: 0 28px;
        position: relative;
        cursor: pointer;
        &.active {
          &::after {
            display: inline-block;
            content: "";
            width: 100%;
            height: 6px;
            background: #292929;
            position: absolute;
            bottom: -7px;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
    }
  }
}
</style>